import { __extends } from "tslib";
import { ShadowMethodBase, _Shader_ShadowMethodBase } from './ShadowMethodBase';
/**
 * ShadowHardMethod provides the cheapest shadow map method by using a single tap without any filtering.
 */
var ShadowHardMethod = /** @class */ (function (_super) {
    __extends(ShadowHardMethod, _super);
    function ShadowHardMethod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ShadowHardMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return ShadowHardMethod.assetType;
        },
        enumerable: false,
        configurable: true
    });
    ShadowHardMethod.assetType = '[asset ShadowHardMethod]';
    return ShadowHardMethod;
}(ShadowMethodBase));
export { ShadowHardMethod };
import { ShaderBase } from '@awayjs/renderer';
/**
 * _Shader_ShadowHardMethod provides the cheapest shadow map method by using a single tap without any filtering.
 */
var _Shader_ShadowHardMethod = /** @class */ (function (_super) {
    __extends(_Shader_ShadowHardMethod, _super);
    function _Shader_ShadowHardMethod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new _Shader_ShadowHardMethod.
     */
    _Shader_ShadowHardMethod.prototype.init = function (method, shader) {
        _super.prototype.init.call(this, method, shader);
    };
    /**
     * @inheritDoc
     */
    _Shader_ShadowHardMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = this._baseTexture._getFragmentCode(targetReg, registerCache, sharedRegisters, this._baseChunk.depthMapCoordReg);
        code += _super.prototype._getFragmentCode.call(this, targetReg, registerCache, sharedRegisters);
        return code;
    };
    return _Shader_ShadowHardMethod;
}(_Shader_ShadowMethodBase));
export { _Shader_ShadowHardMethod };
ShaderBase.registerAbstraction(_Shader_ShadowHardMethod, ShadowHardMethod);
